const RESOURCE_PATH = '/sparing-calculator-web/rest/resource';

const BASE_PATH = `${RESOURCE_PATH}/api`;

export const getApiUrl = (path: string) => `${BASE_PATH}/${path}`;
